import { apiFetch, parseApiResponse } from '../../../utils/apiClient';

export const getTaskAssignableUsers = async () =>
  parseApiResponse(await apiFetch('/api/users/directory'));

export const getUserTasks = async (userId) => {
  try {
    const res = await apiFetch(`/api/tasks/user/${userId}`);
    return await parseApiResponse(res);
  } catch (error) {
    console.error('Error fetching user tasks:', error);
    throw error;
  }
};

export const getTimeTrackableTasks = async (recentDays = 30) => {
  try {
    const res = await apiFetch(`/api/tasks/time-tracking/recent?recentDays=${recentDays}`);
    return await parseApiResponse(res);
  } catch (error) {
    console.error('Error fetching time-trackable tasks:', error);
    throw error;
  }
};

export const getAllTasks = async () => {
  try {
    const res = await apiFetch('/api/tasks');
    return await parseApiResponse(res);
  } catch (error) {
    console.error('Error fetching tasks:', error);
    throw error;
  }
};

export const createTask = async (payload) => {
  try {
    const res = await apiFetch('/api/tasks', {
      method: 'POST',
      body: JSON.stringify(payload),
    });
    const task = await parseApiResponse(res);

    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent('sas-erp-tasks-changed'));
    }

    return task;
  } catch (error) {
    console.error('Error creating task:', error);
    throw error;
  }
};

export const updateTask = async (taskId, payload) => {
  try {
    const res = await apiFetch(`/api/tasks/${taskId}`, {
      method: 'PUT',
      body: JSON.stringify(payload),
    });
    const task = await parseApiResponse(res);

    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent('sas-erp-tasks-changed'));
    }

    return task;
  } catch (error) {
    console.error('Error updating task:', error);
    throw error;
  }
};

export const completeTask = async (taskId) => {
  try {
    const res = await apiFetch(`/api/tasks/${taskId}/complete`, {
      method: 'PUT',
    });
    const task = await parseApiResponse(res);

    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent('sas-erp-tasks-changed'));
    }

    return task;
  } catch (error) {
    console.error('Error completing task:', error);
    throw error;
  }
};

export const reassignPendingLdaTasks = async (ldaLineId, projectId, codeGed, assignedUserId, taskPlanning = {}) => {
  try {
    const params = new URLSearchParams();

    if (projectId) {
      params.set('projectId', projectId);
    }

    if (codeGed) {
      params.set('codeGed', codeGed);
    }

    const query = params.toString() ? `?${params.toString()}` : '';
    const res = await apiFetch(`/api/tasks/lda/${ldaLineId}/pending/reassign${query}`, {
      method: 'PUT',
      body: JSON.stringify({ assignedUserId, ...taskPlanning }),
    });
    const result = await parseApiResponse(res);

    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent('sas-erp-tasks-changed'));
    }

    return result;
  } catch (error) {
    console.error('Error reassigning pending LDA tasks:', error);
    throw error;
  }
};
